// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_VincularPlanoContasInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /despesas/{id}/vincular_plano_contas
 *
 * Links a despesa to a plano de contas (budget account).
 */
import { registerContract } from './validate'

export interface Despesas_VincularPlanoContasInput {
plano_conta_id: number
}

registerContract('Despesas_VincularPlanoContasInput', {
  plano_conta_id: { type: 'number',  required: true },
})
